export const BRAND = {
  name: "SoyDiVa",
  tagline: "¡De Yucatán a tu mesa!",
  city: "Mérida, Yucatán",
  since: 2017,
};

export const WHATSAPP_NUMBER = "5219993898788";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "¡Hola SoyDiVa! Quiero más información 🌶️"
)}`;

export const SOCIALS = {
  instagram: "https://www.instagram.com/salsasdiva",
  tiktok: "https://www.tiktok.com/@salsasdiva",
  facebook: "https://www.facebook.com/p/Salsas-DiVa-61563515460521/",
};

export const PICKUP_ADDRESS =
  "Fraccionamiento Las Américas 2, Mérida, Yucatán (con cita previa)";

// Logo oficial de SoyDiVa (descargado del Linktree oficial de la marca).
// Para reemplazarlo, basta con cambiar esta URL y BrandLogo lo usa en todo el sitio.
export const LOGO_URL = "/assets/soydiva-logo.png";

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/bc1bf8f9-4558-4438-9103-9a969feeecfe/images";

export const HERO_IMAGE =
  "https://customer-assets-v7afamib.emergentagent.net/job_tienda-divinas/artifacts/zaepzdkn_image.png";
export const HISTORIA_IMAGE =
  "https://customer-assets-v7afamib.emergentagent.net/job_tienda-divinas/artifacts/h4kjsb5b_image.png";

export const CATEGORY_LABELS = {
  "no-pican": "Los que no pican",
  machas: "Las Machas",
  habaneros: "Los Habaneros",
  variedad: "La Variedad",
  kit: "Kit especial",
  salsa: "Salsa artesanal",
  crema: "Crema artesanal",
  condimento: "Condimento",
};

export const ORDER_STATUS_LABELS = {
  pendiente_pago: "Pendiente de pago",
  recibido: "Recibido",
  en_preparacion: "En preparación",
  enviado: "Enviado",
  listo_recoger: "Listo para recoger",
  completado: "Completado",
  cancelado: "Cancelado",
};

export const ORDER_STATUS_FLOW = {
  envio: ["recibido", "en_preparacion", "enviado", "completado"],
  pickup: ["recibido", "en_preparacion", "listo_recoger", "completado"],
};

export const money = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(n);
